export default __webpack_public_path__ + "locales/nl/WebPlugins.json?hash=4b597f15ba569abb0e8851b1cf7ffcee";